export const PREVIOUS_PATH_KEY = "previousPath";

export const ACCESS_TOKEN_COOKIE = "accessToken";
export const REFRESH_TOKEN_COOKIE = "refreshToken";
export const ID_TOKEN_COOKIE = "idToken";

// Auth0 error codes for which silent authentication can never recover on its
// own. When any of these is returned, the Auth0 IdP session is gone (or needs
// interaction), so we must trigger an interactive re-login instead of looping
// on failed silent-auth attempts.
export const UNRECOVERABLE_AUTH0_ERRORS = [
  "login_required",
  "interaction_required",
  "consent_required",
  "missing_refresh_token",
  "invalid_grant",
];

export type TokenKey =
  | typeof ACCESS_TOKEN_COOKIE
  | typeof REFRESH_TOKEN_COOKIE
  | typeof ID_TOKEN_COOKIE;
